import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';

import InfoListItem from '~/components/InfoListItem';
import SSOLink from '~/components/SSOLink';
import { useBrandInfo } from '~/hooks/useBrandInfo';
import useFeature from '~/hooks/useFeature';

const FtpAccessInfo = () => {
  const { t } = useTranslation('site');
  const { ftp } = t('scenes.advanced', { returnObjects: true }) as {
    ftp: {
      title: string;
      tooltipText: string;
      manageBtn: string;
    };
  };

  const [hasSites] = useFeature('sites');
  const [isDestiny] = useFeature('destiny');
  const [isCPanel] = useFeature('cpanel');

  const { brandFromJWT } = useBrandInfo();
  const isBlueHost = brandFromJWT.toLowerCase() === 'bluehost';

  if (!hasSites) {
    return null;
  }

  return (
    <InfoListItem
      title={ftp?.title}
      // @ts-expect-error
      tooltipText={ftp?.tooltip}
      {...{
        inlineCTA:
          (isDestiny || isCPanel) && isBlueHost ? (
            <Button variant="text" href={'/ftp-access'} color="primary">
              {ftp?.manageBtn}
            </Button>
          ) : (
            <SSOLink
              variant="text"
              type={'hosting'}
              queryParams={{ app: 'ftp' }}
            >
              {ftp?.manageBtn}
            </SSOLink>
          ),
      }}
    />
  );
};

export default FtpAccessInfo;
